export enum EventItemType {
    FINISHED = "finished",
    UPCOMING = "upcoming",
    MY_FINISHED = "myfinished",
    MY_REGISTERED = "myregistered",
    MY_FAVORITE = "myfavorites"
  }
  